import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/awakeorigins.webp';
import screenshot_target from '../../../images/letterfunnel/franziskaschaadt.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Franziska Schaadt"
      firstname="Franziska"
      companyname="Awake Origins"
      competition="The Argonauts en SOSU Club"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/franziskaschaadt.js